import { Component, Input } from '@angular/core';
import { DetailRow } from '@veritas-shared/models/detail-row.model';

@Component({
  selector: 'app-details-row',
  templateUrl: './details-row.component.html',
  styleUrls: ['./details-row.component.scss']
})
export class DetailsRowComponent<T> {
  @Input() public rows: DetailRow<T>[];

  constructor() { }
}
